<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <strong> Phát triển bởi công ty công nghệ
      <a href="http://thienan.vn/">Thiên An</a>.</strong
    >
  </div>
  <strong>Phần mềm Khảo sát đánh giá <a [routerLink]="['/version-detail']">Version {{version}}</a></strong
  >
</footer>
